var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnXChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    fill: "#CA3131",
    stroke: "#CA3131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02104 7.501L10.8921 4.62994C11.036 4.48606 11.036 4.25279 10.8921 4.10892C10.7482 3.96504 10.5149 3.96504 10.3711 4.10892L7.49999 6.97998L4.62893 4.10892C4.48505 3.96504 4.25178 3.96504 4.10791 4.10892C3.96404 4.2528 3.96403 4.48607 4.10791 4.62994L6.97897 7.501L4.10791 10.3721C3.96403 10.5159 3.96403 10.7492 4.10791 10.8931C4.25179 11.037 4.48506 11.037 4.62893 10.8931L7.49999 8.02202L10.371 10.8931C10.5149 11.037 10.7482 11.037 10.8921 10.8931C11.0359 10.7492 11.0359 10.5159 10.8921 10.3721L8.02104 7.501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnXChart);
export default __webpack_public_path__ + "static/media/btnXChart.86a5ee3ac06967e78dc7676c8071b196.svg";
export { ForwardRef as ReactComponent };